/* eslint-disable class-methods-use-this */
/* eslint-disable quote-props */
/* eslint-disable no-param-reassign */

import qs from 'qs'; // needed for url form encode
import axios from 'axios';

axios.defaults.withCredentials = true;

class WebConn {
  constructor(rootUrl, vm) {
    this.rootUrl = rootUrl;
    this.vm = vm;
    this.token = null;
  }

  setToken(token) {
    this.token = token;
  }

  Debug() {
    console.log('ok2');
    console.log(this.token);
  }

  request(action, objData) {
    return new Promise((resolve, reject) => {
      const objDefault = {
        action,
        token: this.token,
      };

      // merge objects
      const objPostdata = Object.assign(objDefault, objData);

      axios({
        method: 'POST',
        url: this.rootUrl,
        crossDomain: true,
        withCredentials: true,
        data: qs.stringify(objPostdata),
        headers: {
          'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
        },
      }).then((response) => {
        if (response.data.success) {
          resolve(response.data.data);
        } else {
          reject(response.data.data);
        }
      }).catch((error) => {
        console.error(error);
        reject(error);
      });
    });
  }
}

export default {
  install(Vue, options) {
    const webConn = new WebConn(options.rootUrl, Vue);
    Vue.prototype.$webConn = webConn;
    Vue.WebConn = webConn;
    // Vue.mixin({
    //   created() {
    //     console.log('created');
    //     // this.$root.$on('loggedIn', (token) => {
    //     //   console.log('loggedIn Webconn');
    //     //   console.log(token);
    //     // });
    //   },
    // });
  },
};
